import { createSelector } from 'reselect';
import { RootState } from '../../../types';

const id = (state: RootState) => state.core.offline.id;

export const selectOfflineId = createSelector(id, id => id);
